import { Component, inject } from '@angular/core';
import { AuthService } from '../../../../core/services/auth.service';

@Component({
  selector: 'app-final-cta',
  standalone: true,
  template: `
    <section class="final-cta landing-section">
      <span class="big-kanji" aria-hidden="true">続ける</span>
      <div class="reveal">
        <h2 class="landing-h2 wide centered">
          Begin today.<br />Continue <span class="accent">always.</span>
        </h2>
        <p class="final-sub">The path clears as you move.</p>
        <a
          href="#"
          class="nav-cta-button primary"
          (click)="handleSignup($event)"
        >
          Take the first step — free
        </a>
        <p class="final-note">No catalog. One conversation with KΛI.</p>
      </div>
    </section>
  `,
  styleUrl: './final-cta.component.scss',
})
export class FinalCtaComponent {
  private readonly authService = inject(AuthService);

  async handleSignup(event: Event): Promise<void> {
    event.preventDefault();
    try {
      await this.authService.signup();
    } catch {
      // Auth redirect failed — no user-visible action needed here
    }
  }
}
